var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2103,
    height: 2150,
    viewBox: "0 0 69.406 82.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.863 72.166c-1.493 2.513-3.004 4.376-4.821 6.112-2.074 1.816-2.612 3.441-7.362 4.05-3.305.604-6.198-.633-7.335-1.124-3.306-1.53-5.066-2.051-7.078-2.048-1.942-.001-3.651.498-6.928 2.018-1.001.505-3.79 1.72-7.153 1.115-3.477-.615-5.264-1.946-6.52-3.069-2.675-2.346-4.7-4.609-6.491-7.187l53.688.133z",
    fill: "#1996d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.622 30.633c1.591-3.497 3.604-5.871 5.659-7.491 5.221-4.274 13.713-4.57 17.615-3.544 3.193.826 5.492 2.757 9.134 2.765 3.752.002 5.929-1.926 8.931-2.745 3.93-1.006 12.448-.68 17.985 3.602 1.666 1.222 3.163 2.948 4.007 3.864-1.965 1.48-3.206 2.521-4.168 3.542l-59.163.007z",
    fill: "#9fc54d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.785 30.625c-.941 1.019-1.602 2.001-2.35 3.377-.915 1.64-1.974 3.794-2.224 7.117l-57.178.037c.034-.595.089-1.191.157-1.761.52-3.519 1.379-6.415 2.432-8.762l59.163-.008z",
    fill: "#f3e253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.212 41.12c-.068.803-.067 2.181-.016 3.053.166 2.433 1 5.142 2.085 7.326L1.105 51.39C.334 47.875-.131 44.236.033 41.157l57.179-.037z",
    fill: "#e09346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.281 51.499c.511 1.029 1.076 1.934 1.643 2.648 3.843 4.897 5.477 4.908 8.482 6.432-.234.507-.431.995-.634 1.47l-64.286-.124c-1.229-2.726-2.507-6.556-3.381-10.535l58.176.109z",
    fill: "#d35b43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.772 62.049c-1.88 4.365-3.381 7.574-4.909 10.117l-53.688-.133c-1.797-2.594-3.383-5.495-5.22-9.122a875.7 875.7 0 0 1-.469-.986l64.286.124z",
    fill: "#8f559d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.131 6.309c-.31 2.246-1.425 5.085-3.178 6.907-1.944 2.043-4.905 4.28-6.682 5.393-.998.607-3.527.708-5.646.911-.267-1.846-.339-3.471.31-5.194.725-2.04 1.718-4.988 3.261-7.018 1.933-2.544 4.09-4.277 5.293-4.886C45.097 1.619 47.77.396 50.092 0c.087 2.038.384 4.371.039 6.309z",
    fill: "#9fc54d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.38680f77629858296225dcb4cd82739d.svg";
export { ForwardRef as ReactComponent };